import { useEffect, useRef } from "react";
import { initialize, whenAvailable, isFeatureEnabled } from "@vp/ab-reader";

/**
 * Usage:
 * const { enabled, disabled } = useFeatureGate();
 * 
 * if (enabled("new-feature-gate")) {
 *   showNewFlow();
 * } else {
 *   showOldFlow();
 * }
 */
export function useFeatureGate() {
  const isAvailable = useRef(false);

  useEffect(() => {
    initialize();

    whenAvailable((available) => {
      isAvailable.current = available || false;
      if (!available && process.env.NODE_ENV !== "production") {
        console.warn("[useFeatureGate] AB Reader not available — all flags will return false");
      }
    }, 1000);
  }, []);

  const featureGate = () => ({
    enabled: (key: string) => {
      if (!isAvailable.current) return false;
      try {
        return isFeatureEnabled(key);
      } catch {
        return false;
      }
    },
    disabled: (key: string) => !featureGate().enabled(key),
  });

  return featureGate();
}